/* eslint-disable max-lines */
import InlineSvg from "vue-inline-svg";
import BrandValueIcon from "../../../components/shared/brandValueIcon/brandValueIcon.vue";
import FeedEvents from "@/services/feed/events";
import ProductSelector from "./ProductSelector/ProductSelector.vue";
import ThePostPreview from "./ThePostPreview/ThePostPreview.vue";
import FeedAPI from "@/services/feed/feed.js";
import BrandApi from "@/services/api/brandApi";
import { Validator } from "vee-validate";
import CreatePromoCodeModal from "@/views/dashboard/promoCodes/createPromoCodeModal/createPromoCodeModal.vue";
const FeedAPIService = new FeedAPI(),
  BrandAPIService = new BrandApi();

export default {
  components: {
    InlineSvg,
    BrandValueIcon,
    ThePostPreview,
    CreatePromoCodeModal,
    ProductSelector,
  },
  data() {
    return {
      showModal: false,
      showForm: true,
      caption: "",
      imgData: "",
      tags: [],
      searchQuery: "",
      tagDisabled: false,
      description: null,
      currentTag: null,
      draftPost: null,
      feed_events: undefined,
      referer: "test",
      mediaResponse: null,
      creatingPost: false,
      adminLink: {},
      promoCodes: null,
      selectedPromoCode: null,
    };
  },
  methods: {
    handleCreatePostClick,
    handlePublishPostClick,
    addImageCallback,
    imageDropCallback,
    handleTagCreateClick,
    handleTagClick,
    handleUndoClick,
    setProduct,
    handleRemoveClick,
    resetAllActiveStates,
    handleRemoveImageClick,
    getPromoCodeData,
    handlePromoSelected,
    closeCreatePromoCodeModal,
    handleEditableTagClick,
  },
  created() {
    this.$data.feed_events = new FeedEvents(this);
    const validator = new Validator();
    validator.extend("urlBlockList", {
      getMessage: () => "We cannot add the website provided at this time. Please try a different url.",
      validate: (value) => {
        const EXCLUDE_LIST = this.$utils.constants.EXCLUDED_URLS;
        for (const url in EXCLUDE_LIST) {
          if (value.includes(EXCLUDE_LIST[url])) {
            return false;
          }
        }
        return true;
      },
    });
    validator.attach({
      name: "Not Valid",
      rules: "urlBlockList",
    });
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$data) {
        vm.$data.feed_events.track("POST_CREATE_VIEW", from.path, undefined);
      }
    });
  },
  mounted() {
    this.getPromoCodeData();
  },
};

// eslint-disable-next-line complexity
async function handleCreatePostClick() {
  // validation
  const charLimit = 500,
    valid = await this.$validator.validate();
  if (this.imgData === "" || this.caption.length > charLimit) {
    let errors = "";
    if (this.imgData === "") {
      errors += "Please add an image<br/>";
    }
    if (this.caption.length > charLimit) {
      errors += `Max ${charLimit} Characters<br/>`;
    }
    this.$swal("Attention", errors);
    return;
  }
  if (!valid) {
    return this.$swal("Attention", "Please enter a valid link url");
  }

  this.draftPost = {
    tags: this.tags,
    img: this.imgData,
    caption: this.caption,
    ...(this.selectedPromoCode && {
      promo_code: this.selectedPromoCode.name,
    }),
    link: this.adminLink,
  };
  this.showForm = !this.showForm;
  this.resetAllActiveStates();
  this.currentTag = null;
  this.description = null;
}

function handlePublishPostClick() {
  this.creatingPost = true;
  const id = this.mediaResponse.media_id;
  FeedAPIService.createPost({
    content: {
      body: this.caption,
      ...(this.selectedPromoCode && {
        promo_code: this.selectedPromoCode.name,
      }),
    },
    link: {
      url: this.adminLink.url,
    },
    media_id: id,
  })
    .then((response) => {
      this.creatingPost = false;
      this.$data.feed_events.track("PUBLISH_POST", this.draftPost, this.$session.getUserInfo());
      this.selectedPromoCode &&
        this.$data.feed_events.track(
          "PROMO ADDED TO POST",
          {
            post_id: response.data.post_id,
            promo_code: this.selectedPromoCode,
          },
          this.$session.getUserInfo()
        );
      this.$router.push("/plus");
    })
    .catch((error) => {
      this.creatingPost = false;
      this.$logger.notify(error);
      this.$swal("Oops!", "Something went wrong. Please try again or contact support.");
      throw error;
    });
}

function imageDropCallback(file) {
  const formData = new FormData();
  FeedAPIService.createMediaObject().then(async ({ data }) => {
    this.mediaResponse = data;
    const uploadUrl = data.upload_original_image.url,
      fields = data.upload_original_image.fields;
    for (const field in fields) {
      formData.append(field, fields[field]);
    }
    formData.append("file", file);
    fetch(uploadUrl, {
      method: "POST",
      body: formData,
    }).then(() => {
      this.$data.feed_events.track("ORIGINAL_IMAGE_UPLOADED", this.mediaResponse, undefined);
    });
  });
}

function addImageCallback(imgData) {
  this.imgData = imgData.src;
  const formData = new FormData(),
    uploadUrl = this.mediaResponse.upload_cropped_image.url;
  for (const field in this.mediaResponse.upload_cropped_image.fields) {
    formData.append(field, this.mediaResponse.upload_cropped_image.fields[field]);
  }
  formData.append("file", imgData.file);
  fetch(uploadUrl, {
    method: "POST",
    body: formData,
  }).then(() => {
    this.$data.feed_events.track("CROPPED_IMAGE_UPLOADED", this.mediaResponse, undefined);
  });
}

function handleTagCreateClick(event) {
  this.resetAllActiveStates();
  const rect = event.target.getBoundingClientRect(),
    left = event.clientX - rect.left,
    bottom = event.clientY - rect.top;
  this.currentTag = {
    left: left / rect.width,
    bottom: (rect.height - bottom) / rect.height,
    coords: `${left / rect.width}, ${(rect.height - bottom) / rect.height}`,
    activated: false,
    isEditable: true,
  };
}

function handleTagClick(tag) {
  tag.activated = !tag.activated;
  this.currentTag = null;
}
function handleEditableTagClick() {
  this.currentTag = null;
}

function handleUndoClick() {
  this.currentTag = null;
}

function setProduct(productData) {
  this.currentTag = {
    ...this.currentTag,
    ...productData,
  };
  this.currentTag.activated = false;
  this.currentTag.isEditable = false;
  this.tags.push(this.currentTag);
  this.currentTag.pos = this.tags.length - 1;
  this.description = this.currentTag;
  this.currentTag = null;
  this.searchQuery = "";

  const { categories, tag_type } = productData;
  const firstCategory = categories && categories.length ? categories[0] : null;
  const categoryName = firstCategory ? firstCategory.name : "";
  const parentCategoryName = firstCategory ? firstCategory.parent_category : "";

  FeedAPIService.addTagToMediaObject(this.mediaResponse.media_id, {
    tag: {
      coords: this.description.coords,
      title: this.description.title,
      url: this.description.url,
      wholesale_price: this.description.wholesale_price,
      retail_price: this.description.retail_price,
      category: categoryName,
      tag_type: tag_type,
      parent_category: parentCategoryName,
    },
  }).then((response) => {
    this.$data.feed_events.track("TAG_CREATED", this.mediaResponse, productData);
    // adding the tag Id to the tag that was just created, it is need for  DELETE operation
    this.tags[this.tags.length - 1].tag_id = response.data.tag_id;
  });
}

function handleRemoveClick(index) {
  const mediaId = this.mediaResponse.media_id,
    tagID = this.tags[index].tag_id,
    tagParentCategory = this.tags[index].parent_category,
    tagType = this.tags[index].tag_type,
    tagLength = this.tags.length;

  this.$delete(this.tags, index);
  this.description = null;

  FeedAPIService.removeTagFromMediaObject(mediaId, tagID).then(() => {
    this.$data.feed_events.track(
      "TAG_DELETED",
      {
        media_id: mediaId,
        total_tags: tagLength,
      },
      {
        tag_type: tagType,
        parent_category: tagParentCategory,
      }
    );
  });
}

function resetAllActiveStates() {
  this.tags.map((tag) => {
    tag.activated = false;
    return {
      tag,
    };
  });
}

function handleRemoveImageClick() {
  this.$nextTick(() => {
    this.imgData = "";
    this.currentTag = null;
    this.tags = [];
    this.description = "";
  });
}

async function getPromoCodeData() {
  if (this.$session.getUserInfo().role === "BRAND") {
    const { data } = await BrandAPIService.getMyBrandPromoCodes();
    this.promoCodes = data.promo_codes.map((code) => {
      return {
        message: code.message,
        name: code.promo_code,
      };
    });
    this.promoCodes.unshift({
      name: "NONE",
      message: "NONE",
    });
  }
}

function handlePromoSelected(code) {
  if (code.name !== "NONE") {
    this.selectedPromoCode = code;
  }
}

function closeCreatePromoCodeModal(codeCreated) {
  this.showModal = false;
  if (codeCreated) {
    this.getPromoCodeData();
  }
}
